export default class Widget {
  constructor(node) {
    this.node = node

    this.hero = document.querySelector('.js-hero')

    this.footer = document.querySelector('.footer')

    this.heroOffset = this.hero.offsetHeight
    this.footerOffset = this.footer.offsetHeight

    this.handleScroll = this.handleScroll.bind(this)

    this.init()
  }

  init() {
    console.debug('  -> Menu init')
    this.reset()
    this.addListeners()
  }

  addListeners() {
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll(e) {
    const heroOffset = 50

    const scrollTop = window.scrollY || document.documentElement.scrollTop
    const windowHeight = window.innerHeight
    const docHeight = document.documentElement.offsetHeight
    const scrollBottom = docHeight - windowHeight - scrollTop

    if(this.node){
      if (scrollTop > this.heroOffset || scrollBottom > this.footerOffset) {
        this.node.classList.remove('is-hidden')
      }

      if (scrollTop <= this.heroOffset || scrollBottom <= this.footerOffset) {
        this.node.classList.add('is-hidden')
      }
    }
    
  }

  reset() {
    console.debug('  -> Widget reset')
  }

  static destroy() {}

  static init() {
    console.debug('== Contact Widget component ==')
    Widget.item = new Widget(document.querySelector('.contacts-widget'))
  }
}
